function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 277.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.7,259.26H69.44c-6.17,0-6.17-9.26,0-9.26H78.7C84.88,250,84.88,259.26,78.7,259.26ZM97.22,27.78H50.93c-6.18,0-6.18-9.26,0-9.26H97.22C103.39,18.52,103.39,27.78,97.22,27.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,277.77H23.15A23.15,23.15,0,0,1,0,254.63V23.15A23.16,23.16,0,0,1,23.15,0H125a23.16,23.16,0,0,1,23.15,23.15v37c0,6.18-9.26,6.18-9.26,0v-37A13.89,13.89,0,0,0,125,9.26H23.15A13.89,13.89,0,0,0,9.26,23.15V254.63a13.9,13.9,0,0,0,13.89,13.89H125a13.9,13.9,0,0,0,13.89-13.89c0-6.18,9.26-6.18,9.26,0A23.15,23.15,0,0,1,125,277.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,240.74H88c-6.17,0-6.17-9.26,0-9.26h9.26c29.22,0,97.22-13.08,97.22-134.26V64.81H180.55a4.61,4.61,0,0,1-4-6.93L209,2.32a4.81,4.81,0,0,1,8,0l32.41,55.56a4.61,4.61,0,0,1-4,6.93H231.48V97.22c0,6.17-9.26,6.17-9.26,0v-37a4.63,4.63,0,0,1,4.63-4.63h10.47L213,13.79,188.6,55.55h10.47a4.63,4.63,0,0,1,4.63,4.63v37C203.7,226.75,129.25,240.74,97.22,240.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,115.74c0,6.17-9.26,6.17-9.26,0s9.26-6.17,9.26,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,92.59a60.19,60.19,0,1,0,60.19,60.19A60.27,60.27,0,0,0,97.22,92.59Zm0,129.63a69.45,69.45,0,1,1,69.44-69.44A69.52,69.52,0,0,1,97.22,222.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,111.11a4.32,4.32,0,0,1-3.23-1.4,4.48,4.48,0,0,1-1.4-3.23,4.63,4.63,0,0,1,1.3-3.23,4.81,4.81,0,0,1,6.57,0,4.35,4.35,0,0,1,1.39,3.23,4.81,4.81,0,0,1-1.3,3.23A4.71,4.71,0,0,1,97.22,111.11Zm0,92.59A4.57,4.57,0,0,1,94,195.84a4.68,4.68,0,0,1,6.47,0,4.63,4.63,0,0,1-3.24,7.86Zm-20.83-87a4.44,4.44,0,0,1-3.53.43A4.54,4.54,0,0,1,70,115a4.82,4.82,0,0,1-.53-3.47,4.71,4.71,0,0,1,5.69-3.27A4.43,4.43,0,0,1,78,110.38a4.67,4.67,0,0,1-1.68,6.37Zm46.3,80.2a4.44,4.44,0,0,1-3.53.43,4.52,4.52,0,0,1-2.84-2.12c-2.37-5.15,4.78-9.26,8-4.62a4.41,4.41,0,0,1,.43,3.52,4.5,4.5,0,0,1-2.11,2.84ZM61.1,132a4.77,4.77,0,0,1-6.36,1.68,4.57,4.57,0,0,1-2.17-2.74,4.74,4.74,0,0,1,3.27-5.69,4.46,4.46,0,0,1,3.53.43,4.7,4.7,0,0,1,2.16,2.74A4.56,4.56,0,0,1,61.1,132Zm80.19,46.29a4.46,4.46,0,0,1-2.83,2.12,4.28,4.28,0,0,1-3.52-.44,4.56,4.56,0,0,1-2.13-2.84,4.67,4.67,0,0,1,6.76-5.21,4.48,4.48,0,0,1,2.12,2.84,4.27,4.27,0,0,1-.44,3.49ZM55.51,152.83a4.37,4.37,0,0,1-1.4,3.23,4.69,4.69,0,0,1-6.52.09,4.86,4.86,0,0,1,0-6.61,4.4,4.4,0,0,1,3.24-1.39,4.59,4.59,0,0,1,4.63,4.63Zm92.59,0a4.2,4.2,0,0,1-1.4,3.23,4.46,4.46,0,0,1-6.47,0,4.68,4.68,0,0,1,0-6.47,4.64,4.64,0,0,1,7.87,3.24Zm-87,20.82a4.23,4.23,0,0,1,.38,3.53A4.28,4.28,0,0,1,59.37,180a4.56,4.56,0,0,1-3.48.53,4.7,4.7,0,0,1-3.27-5.69A4.46,4.46,0,0,1,54.74,172a4.64,4.64,0,0,1,6.36,1.73Zm80.19-46.29a4.29,4.29,0,0,1,.44,3.53,4.34,4.34,0,0,1-2.11,2.79,4.47,4.47,0,0,1-3.54.43,4.63,4.63,0,0,1-3.22-5.59,4.45,4.45,0,0,1,2.13-2.84,4.39,4.39,0,0,1,3.51-.43,4.19,4.19,0,0,1,2.84,2.11ZM76.39,189a4.33,4.33,0,0,1,2.12,2.84,4.58,4.58,0,0,1-3.14,5.64,4.73,4.73,0,0,1-5.68-3.27,4.67,4.67,0,0,1,.38-3.53,5.16,5.16,0,0,1,2.74-2.16,4.68,4.68,0,0,1,3.62.43Zm46.3-80.2a4.36,4.36,0,0,1,2.11,2.84,4.11,4.11,0,0,1-.43,3.47,4.39,4.39,0,0,1-2.84,2.12,4.66,4.66,0,0,1-5.64-3.23,4.45,4.45,0,0,1,.43-3.52,4.55,4.55,0,0,1,2.84-2.12,4.36,4.36,0,0,1,3.48.44ZM106.48,74.07H88c-6.17,0-6.17-9.26,0-9.26h18.52C112.65,64.81,112.65,74.07,106.48,74.07ZM59.12,105a4.66,4.66,0,0,1-3.76-1.93L47.21,91.83c-3.62-5,3.86-10.42,7.48-5.46L62.84,97.6a4.62,4.62,0,0,1-3.77,7.34Zm76.2,0a4.6,4.6,0,0,1-3.72-7.34l8.15-11.23a4.62,4.62,0,0,1,7.48,5.44l-8.15,11.25a4.66,4.66,0,0,1-3.76,1.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,143.52a9.05,9.05,0,0,1,4.63,1.39V106.48c0-6.17-9.26-6.17-9.26,0v38.43A8.89,8.89,0,0,1,97.22,143.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,148.15c-6.17,0-6.17,9.3,0,9.26S103.39,148.15,97.22,148.15Zm0,18.51a13.89,13.89,0,1,1,13.89-13.88A13.89,13.89,0,0,1,97.22,166.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,152.78c0,6.17-9.26,6.17-9.26,0s9.26-6.18,9.26,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,171.29c0,6.18-9.26,6.18-9.26,0s9.26-6.17,9.26,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.85,259.26h-46.3c-6.17,0-6.17-9.26,0-9.26h41.67V217.59c0-6.17,9.26-6.17,9.26,0v37A4.64,4.64,0,0,1,226.85,259.26Zm0-55.56a4.63,4.63,0,0,1-4.63-4.63v-9.26c0-6.17,9.26-6.17,9.26,0v9.26A4.63,4.63,0,0,1,226.85,203.7Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.61ebc824791044c0c68c12349236d522.svg";
export { ForwardRef as ReactComponent };